// Module
var code = `<template class="ag-numeric-editor">
  <require from="./agNumericEditor.scss"></require>
  <input ref="inputElement" focus.bind="hasFocus" value.bind="value">
</template>
`;
// Exports
export default code;